import { createSlice } from '@reduxjs/toolkit';

export const optionalFormConfig = createSlice({
  name: 'OPTIONAL_FORM_CONFIG',
  initialState: {}, // comes from preloadedState in the store

  reducers: {
    setAutoScrollEnabled(state, action) {
      return {
        ...state,
        isAutoScrollEnabled: action.payload?.isAutoScrollEnabled,
      };
    },
    setIFrameId(state, action) {
      return {
        ...state,
        iFrameId: action.payload?.iFrameId,
      };
    },
    setWidgetLabel(state, action) {
      return {
        ...state,
        widgetLabel: action.payload?.widgetLabel,
      };
    },
    setIsConsentStatementAboveNavigation(state, action) {
      return {
        ...state,
        isConsentStatementAboveNavigation:
          action.payload?.isConsentStatementAboveNavigation,
      };
    },
    setDynamicHeightEnabled(state, action) {
      return {
        ...state,
        isDynamicHeightEnabled: action.payload?.isDynamicHeightEnabled,
      };
    },
    setAllInitialMessagesArrived(state, action) {
      return {
        ...state,
        haveAllInitialMessagesArrived:
          action.payload?.haveAllInitialMessagesArrived,
      };
    },
    setMinimumWidgetHeight(state, action) {
      return {
        ...state,
        minimumWidgetHeight: action.payload?.minimumWidgetHeight,
      };
    },
    setMaximumWidgetHeight(state, action) {
      return {
        ...state,
        maximumWidgetHeight: action.payload?.maximumWidgetHeight,
      };
    },
    addRegisteredEventHandlers(state, action) {
      const { payload } = action;
      const { registeredEventHandlers } = payload;

      return {
        ...state,
        registeredEventHandlers: [
          // Unique add to or create registered event handlers
          ...new Set([
            ...(state.registeredEventHandlers || []),
            ...registeredEventHandlers,
          ]),
        ],
      };
    },
    addRegisteredEventHandler(state, action) {
      const { payload } = action;
      const { eventHandler } = payload;
      if (
        !eventHandler ||
        !state.registeredEventHandlers.indexOf(eventHandler)
      ) {
        return;
      }

      state.registeredEventHandlers.push(eventHandler);
    },
    setWidgetResizeDuration(state, action) {
      const { payload } = action;
      const { widgetResizeDuration } = payload;
      return {
        ...state,
        widgetResizeDuration,
      };
    },
    setTestMode(state, action) {
      const { payload } = action;
      const { testMode } = payload;
      return {
        ...state,
        testMode,
      };
    },
    setFontOverride(state, action) {
      const { payload } = action;
      const { fontOverride } = payload;
      return {
        ...state,
        fontOverride,
      };
    },
    setUseCidFromURL(state, action) {
      const { payload } = action;
      const { useCidFromURL } = payload;
      return {
        ...state,
        useCidFromURL,
      };
    },
  },
});

const { actions, reducer } = optionalFormConfig;

export const {
  setIFrameId,
  addRegisteredEventHandlers,
  addRegisteredEventHandler,
  setTestMode,
  setWidgetLabel,
  setFontOverride,
  setIsConsentStatementAboveNavigation,
  setAutoScrollEnabled,
  setDynamicHeightEnabled,
  setAllInitialMessagesArrived,
  setMinimumWidgetHeight,
  setMaximumWidgetHeight,
  setUseCidFromURL,
  setWidgetResizeDuration,
} = actions;

export default reducer;
